import type { SlimModel } from '@cplug/frontend-core/models'

export enum CatalogProductBalanceType {
  Weight = 'weight',
  Value = 'value',
  Unit = 'unit'
}

export interface CatalogProductBalance extends SlimModel {
  balanceType?: CatalogProductBalanceType
  barcodes?: string[]
}
